import React from "react";
import resultBarImageLarge from "../../../assets/images/result-bar-large.svg";
import resultBarImageSmall from "../../../assets/images/result-bar-small.png";
import mystryWordImg from "../../../assets/images/tw/mystry-word-img.png";

const ResultBarCard = (props) => {
  const { text, size = "lg", finalScore } = props;
  return (
    <>
      {/* <div className="resultBarCardWrapper">
        <div className="text-center">
          <img src={mystryWordImg} alt="" />
        </div>
        <div
          className={`resultBarCard ${size}`}
          style={{
            backgroundImage: `url(${size === "lg" ? resultBarImageLarge : ""})`,
          }}
        >
          <p className="text">{text}</p>
        </div>
      </div> */}
      <div className="tw-final-result">
        <div className="tw-final-text">
          <h2 className="txt">awesome!</h2>
        </div>
        <div className="tw-final-score">
          <h3 className="score">final score</h3>
          <p className="score-value">{finalScore}</p>
        </div>
        <div className="blank-div"></div>
      </div>
    </>
  );
};

export default ResultBarCard;
